import JustFoRole from "../JustFoRole";

export default JustFoRole("staff");
